/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {useMemo} from 'react'
import {Box, SimpleGrid, HStack, Text, Center, useMultiStyleConfig, Button} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const ColorRefinement = ({value, activeStyles, styles, selectedFilters, toggleFilter, filter}) => {
    const isSelected = useMemo(
        () => selectedFilters?.includes(value.value),
        [selectedFilters, value.value]
    )

    const swatchStyles = isSelected ? activeStyles : styles
    return (
        <HStack
            onClick={() => toggleFilter(value, filter.attributeId, isSelected)}
            spacing={2}
            cursor="pointer"
        >
            <Button
                {...swatchStyles.swatch}
                aria-checked={isSelected}
                aria-label={value.value}
                role="checkbox"
                variant="outline"
                // Override the default hover
                background="none"
            >
                <Center
                    {...styles.swatchButton}
                    border={value.label.toLowerCase() === 'white' && '1px solid black'}
                >
                    <Box
                        height="100%"
                        width="100%"
                        minWidth="32px"
                        backgroundRepeat="no-repeat"
                        backgroundSize="cover"
                        backgroundColor={value.value}
                        background={
                            // value.presentationId.toLowerCase() ===
                            //     'miscellaneous' &&
                            // cssColorGroups[value.presentationId.toLowerCase()]
                            true
                        }
                    />
                </Center>
            </Button>
            <Text
                textStyle={isSelected ? 'Semi Bold Medium' : 'Regular Medium'}
                sx={{hyphens: 'auto'}}
                minWidth={0}
            >
                {value.label}
            </Text>
            <Text
                display={{lg: 'none'}}
                backgroundColor="stokkeGray.bright"
                borderRadius={5}
                paddingY={0.5}
                paddingX={1.5}
                textStyle="Light Medium"
            >
                {value.hitCount}
            </Text>
        </HStack>
    )
}

ColorRefinement.propTypes = {
    value: PropTypes.object,
    activeStyles: PropTypes.object,
    styles: PropTypes.object,
    selectedFilters: PropTypes.array,
    toggleFilter: PropTypes.func,
    filter: PropTypes.object
}

const ColorRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const styles = useMultiStyleConfig('SwatchGroup', {
        variant: 'circle',
        disabled: false
    })

    const activeStyles = useMultiStyleConfig('SwatchGroup', {
        variant: 'circle',
        disabled: false,
        selected: true
    })

    return (
        <SimpleGrid columns={{base: 2, lg: 3}} spacing={4} mt={1}>
            {filter.values
                .filter((refinementValue) => refinementValue.hitCount > 0)
                .map((value, idx) => {
                    return (
                        <ColorRefinement
                            key={idx}
                            value={value}
                            activeStyles={activeStyles}
                            styles={styles}
                            selectedFilters={selectedFilters}
                            toggleFilter={toggleFilter}
                            filter={filter}
                        />
                    )
                })}
        </SimpleGrid>
    )
}

ColorRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default ColorRefinements
